import iconFilterRemove from '@/core/assets/images/icons/filter-remove.svg';

const EmptyResultsHeader = ({ parent, listeners }) => {
    const { $t } = parent;

    const localeStartPath = 'results.emptyResultsFilters';

    const emitResetFilters = (event) => {
        listeners['reset-filters'](event);
    };

    return (
        <div class="l-ss-c-results-empty-filters-header">
            <i domPropsInnerHTML={iconFilterRemove}></i>
            <div class="l-ss-c-results-empty-filters-message">
                <strong>{$t(`${localeStartPath}.title`)}</strong>
                <span>{$t(`${localeStartPath}.tryAgain.1`)} <button onClick={emitResetFilters}>{$t(`${localeStartPath}.tryAgain.2`)}</button></span>
            </div>
        </div>
    );
};

export default EmptyResultsHeader;
